var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnrok = function SvgAnrok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#1D192F",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17.25 11h5.3c.12.24.22.48.35.7l5.84 9.56c.4.66.84 1.29 1.26 1.93v2.15l-1.79 3.06c-.13.23-.29.33-.57.33-1.42-.02-2.84-.02-4.26 0-.3 0-.47-.09-.62-.33-.97-1.61-1.96-3.2-2.94-4.8l-.22-.34a.61.61 0 0 0-.03.35 4.44 4.44 0 0 1-1.55 4.22A5.5 5.5 0 0 1 15.29 29h-.98l-.22-.08a4.66 4.66 0 0 1-3.85-3.2c-.11-.3-.16-.62-.24-.94v-.84c.03-.1.07-.2.09-.31a4.79 4.79 0 0 1 5.29-3.85c1.03.12 1.92.54 2.74 1.15a1.23 1.23 0 0 0-.15-.38c-.95-1.55-1.89-3.1-2.85-4.64-.2-.32-.24-.56-.04-.9.47-.76.89-1.55 1.32-2.34.3-.55.57-1.11.85-1.67Z",
    clipRule: "evenodd"
  })));
};
export default SvgAnrok;